import * as React from 'react';

/**
 * Returns a mutable ref object whose `.current` property always contains the latest value.
 *
 * This is useful for accessing up-to-date state or props inside asynchronous callbacks,
 * event handlers, or closures, where the value might otherwise become stale due to React's
 * state batching and closure behavior.
 *
 * @param {T} value - The value to keep in sync with the ref.
 * @returns {{ current: T }} A ref object with the latest value.
 */
export function useWatchState<T>(value: T): {
    current: T;
} {
    const ref = React.useRef<T>(value);
    React.useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref;
}
